import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import AppErrorBoundary from "./components/AppErrorBoundary";
import { installSafeToast } from "./utils/safeToast";

// Envío ER-2 · los toasts nunca reciben objetos que tiren la app abajo.
installSafeToast();

// Suppress ResizeObserver loop error (common React issue, safe to ignore)
const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

// Also suppress the error in error handlers
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

// Get Clerk publishable key from environment
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));

// Render app with or without Clerk based on configuration
if (CLERK_PUBLISHABLE_KEY) {
  root.render(
    <React.StrictMode>
      <ClerkProvider 
        publishableKey={CLERK_PUBLISHABLE_KEY}
        appearance={{
          variables: {
            colorPrimary: '#10b981',
            colorBackground: '#1a1a2e',
            colorText: '#e5e5e5',
            colorTextSecondary: '#a1a1aa',
            colorInputBackground: '#16213e',
            colorInputText: '#e5e5e5',
            borderRadius: '8px',
          }
        }}
      >
        <BrowserRouter>
          <AppErrorBoundary>
            <App />
          </AppErrorBoundary>
        </BrowserRouter>
      </ClerkProvider>
    </React.StrictMode>
  );
} else {
  // Clerk not configured - run without authentication
  console.warn('REACT_APP_CLERK_PUBLISHABLE_KEY not set - running without authentication');
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>
  );
}
